import React, { PureComponent } from 'react'
import { View, TouchableOpacity } from 'react-native'
import styled from 'styled-components/native'

import theme from '../../../../styles/theme'

import { Text } from '../../../Atoms/Typography'
import TranslatedText from '../../../Atoms/TranslatedText'
import PageHeader from '../../../Molecules/PageHeader'

import { mapNames } from '../../../../lib/business-formatters'

import { translate } from '../../../../services/translate'

const Container = styled(View)`
  flex: 1;
  background: #fff;
  border-bottom-width: 1px;
  border-bottom-color: #ddd;
`

const Table = styled(View)`
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
`

const TableRow = styled(View)`
  flex-direction: row;
  border-bottom-width: ${({ noBorder }) => noBorder ? 0 : '1px'};
  ${({ noBorder, darkBorder }) => noBorder ? '' : darkBorder ? `border-bottom-color: ${theme.colours.bordergrey};` : 'border-bottom-color: #ddd;'}
  ${({ pad }) => pad ? `padding: ${theme.gutterUnit / 2}px;` : ''}
  flex-grow: ${({ grow }) => `${grow || 0};`}
  align-items: center;
`

const TableHeaderSwitcher = styled(View)`
  border-right-width: 1px;
  border-right-color: ${theme.colours.bordergrey};
  width: 30%;
  height: 100%;
  padding: 0 ${theme.gutterUnit * 2}px;
`

const TableHeaderSwitcherInner = styled(View)`
  flex-grow: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const MarketShareToggle = styled(TouchableOpacity)`
  width: 60px;
  background: ${theme.colours.primary};
  height: 40px;
  margin: 0 10px;
  border-radius: 4px;
`

const MarketShareToggleIndicator = styled(View)`
  position: absolute;
  left: ${props => props.on ? '30px' : '3px'};
  top: 3px;
  width: 27px;
  height: 34px;
  background:  ${theme.colours.white};
  border-radius: 4px;
`

const TableHeaderBusinessWrapper = styled(View)`
  width: 70%;
  flex-direction: row;
`

const TableHeaderBusinessButton = styled(TouchableOpacity)`
  background: ${({ background }) => background};
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  max-height: 50px;
  border-radius: 6px;
  flex-direction: row;
  margin: 10px;
  width: 17.5%;
  min-height: 50px;
  padding: 0 ${theme.gutterUnit}px;
`

const TableCellLeft = styled(View)`
  border-right-width: 1px;
  border-right-color: ${theme.colours.bordergrey};
  width: 30%;
  height: 100%;
  align-items: center;
  flex-direction: row;
  padding: ${theme.gutterUnit / 2}px ${theme.gutterUnit * 2}px;
`

const TableCellOthers = styled(View)`
  border-right-width: 1px;
  border-right-color: ${theme.colours.bordergrey};
  width: 17.5%;
  padding: ${({ noPad }) => noPad ? 0 : `${theme.gutterUnit / 2}px ${theme.gutterUnit}px`};
  flex-direction: ${props => props.column ? 'column' : 'row'};
  height: 100%;
  align-items: center;
  ${props => props.column ? '' : 'justify-content: center;'}
`

const textCellOverrides = ({ colour } = { colour: theme.colours.black }) => ({
  width: '50%',
  textAlign: 'center',
  color: colour
})

function formatThousands (n) {
  var parts = n.toString().split('.')
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
}

const formatValue = (type, prop, value, activeBusiness) => {
  if (value === 0) return '-'
  if (type === 'npat' && prop === 'value') {
    return value < 0 ? `(${formatThousands(Math.abs(value))})` : formatThousands(value)
  }
  switch (types[type][prop]) {
    case 'thousands':
      return formatThousands(parseInt(parseFloat(value / 1000).toFixed(0)))
    case 'millions':
      return formatThousands(value)
    case 'percentage':
      return Math.abs(parseFloat(value / 100).toFixed(2)) === 0 ? '-' : parseFloat(value / 100).toFixed(2) + '%'
    case 'number':
      return formatThousands(value % 1 === 0 ? value : parseFloat(value).toFixed(2))
    case 'dollars':
      return value % 1 === 0 ? value : activeBusiness === 'CREDIT_CARDS' ? parseFloat(value).toFixed(0) : parseFloat(value).toFixed(2)
    case 'points':
      return Math.abs(parseFloat(value / 100).toFixed(2)) === 0 ? '-' : parseFloat(value / 100).toFixed(2)
    case 'bps':
      return Math.abs(parseFloat(value).toFixed(2)) === 0 ? '-' : parseFloat(value).toFixed(0) + ' Bps'
  }
}

const formatUnitLabel = (type, value) => {
  switch (type) {
    case 'millions':
      return '$ AUDm'
    case 'percentage':
      return '%'
    case 'thousands':
      return '(000\'s)'
    case 'bps':
      return 'BPS'
    case 'dollars':
      return '$'
    case 'number':
      return '#'
    case 'points':
      return 'Points'
  }
}

const types = {
  balances: {
    value: 'millions',
    change: 'percentage'
  },
  interestRate: {
    value: 'percentage',
    change: 'bps'
  },
  commission: {
    value: 'bps',
    change: 'bps'
  },
  npat: {
    value: 'millions',
    change: 'percentage'
  },
  annualFee: {
    value: 'dollars',
    change: 'dollars'
  },
  loyaltyPoints: {
    value: 'points',
    change: 'points'
  },
  customers: {
    value: 'thousands',
    change: 'percentage'
  },
  branches: {
    value: 'number',
    change: 'number'
  },
  marketShare: {
    value: 'percentage',
    change: 'bps'
  },
  fundsUnderManagement: {
    value: 'millions',
    change: 'percentage'
  },
  managementFees: {
    value: 'percentage',
    change: 'bps'
  }
}

const calculateChange = (type, value, lastValue) => {
  switch (types[type].change) {
    case 'percentage':
      return (value / lastValue - 1) * 10000
    default:
      return value - lastValue
  }
}

const getValue = (type, value, lastValue) => formatValue(type, 'value', value)
const getChange = (type, value, lastValue) => formatValue(type, 'change', calculateChange(type, value, lastValue))

const getChangeColor = (type, value, lastValue) => {
  const change = calculateChange(type, value, lastValue)
  return parseFloat(change) < 0 ? theme.colours.red : theme.colours.green
}

const displayChange = (change) => {
  if (change !== '-' && (parseFloat(change) > 999 || parseFloat(change) < -999)) return 'Large'
  return change
}

const getTypeUnitLabel = (type) => formatUnitLabel(types[type].value)

const getTotals = (type, data, activeBusiness) => {
  let value = data.reduce((acc, { values }) => acc + values[type], 0)
  if (['annualFee', 'loyaltyPoints', 'managementFee'].includes(type) || ['bps', 'percentage'].includes(types[type].value)) { // do sumproduct
    value = data.reduce((acc, { values }) => acc + values.marketShare / 100 * values[type] / 100, 0)
  }
  if (type === 'marketShare') {
    value = 10000
  }
  if (Object.prototype.hasOwnProperty.call(data[0], 'lastValues')) {
    const lastRound = data.reduce((acc, { lastValues }) => acc + lastValues[type], 0)
    let change = value - lastRound
    if (['annualFee', 'loyaltyPoints'].includes(type) || ['percentage'].includes(types[type].change)) { // do sumproduct using change
      change = data.reduce((acc, { values, lastValues }) => acc + values.marketShare / 100 * calculateChange(type, values[type], lastValues[type]) / 100, 0)
    }
    if (types[type].change === 'bps') {
      change = data.reduce((acc, { values }) => acc + values.marketShare / 100 * values[type] / 100, 0) - data.reduce((acc, { lastValues }) => acc + lastValues.marketShare / 100 * lastValues[type] / 100, 0)
    }
    if (['npat', 'balances'].includes(type)) {
      change = (value / lastRound - 1) * 10000
    }
    if (type === 'fundsUnderManagement') {
      change = ((value - lastRound) / lastRound) * 10000
    }
    if (type === 'marketShare') change = null
    return {
      value: formatValue(type, 'value', value, activeBusiness),
      change: change ? formatValue(type, 'change', change, activeBusiness) : '-'
    }
  } else {
    return {
      value: formatValue(type, 'value', value, activeBusiness),
      change: '-'
    }
  }
}

export default class MarketShare extends PureComponent {
  componentDidMount () {
    if (this.props.activeBusiness === null) {
      this.props.setActiveBusiness(this.props.marketShare[0].type)()
    }
  }

  render () {
    const {
      marketShare,
      setActiveBusiness,
      activeBusiness,
      selectedRound,
      currentTeam,
      toggleMarketShare,
      marketShareActive
    } = this.props
    const activeBusinessData = marketShare.find(({ type }) => type === activeBusiness)
    return (
      <Container>
        <PageHeader text={translate('peerInsights.screen2.screenHeader', 'PEER PRICING AND MARKET SHARE').toUpperCase()} />
        {activeBusinessData &&
          <Table>
            <TableRow>
              <TableHeaderSwitcher>
                {Object.keys(activeBusinessData.teams[0].values).length > 4 &&
                  <TableHeaderSwitcherInner>
                    <Text size='m' primary={!marketShareActive} bold>{activeBusiness === 'CREDIT_CARDS' ? translate('peerInsights.screen2.customers', 'Customers') : translate('peerInsights.screen2.balances', 'Balances')}</Text>
                    <MarketShareToggle onPress={toggleMarketShare()}>
                      <MarketShareToggleIndicator on={marketShareActive} />
                    </MarketShareToggle>
                    <TranslatedText size='m' primary={marketShareActive} bold value='peerInsights.screen2.marketShare' default='Market Share' />
                  </TableHeaderSwitcherInner>}
              </TableHeaderSwitcher>
              <TableHeaderBusinessWrapper>
                {marketShare.map(({ type }, i) => (
                  <TableHeaderBusinessButton key={i} onPress={setActiveBusiness(type)} background={type === activeBusiness ? theme.colours.blue : theme.colours.chart.blue}>
                    <Text white size='m' center>{mapNames(type).toUpperCase()}</Text>
                  </TableHeaderBusinessButton>
                ))}
              </TableHeaderBusinessWrapper>
            </TableRow>
            <TableRow style={{ backgroundColor: theme.colours.grey }}>
              <TableCellLeft>
                <Text size='s' medium>BANK</Text>
              </TableCellLeft>
              {Object.keys(activeBusinessData.teams[0].values).filter((k, i, arr) => {
                if (!marketShareActive && arr.length > 4) {
                  return k !== 'marketShare'
                } else if (marketShareActive && arr.length > 4) {
                  if (activeBusiness === 'CREDIT_CARDS' && arr.length > 4) {
                    return k !== 'customers'
                  } else {
                    return k !== 'balances'
                  }
                }
                return true
              }).map(k => (
                <TableCellOthers key={k} column noPad>
                  <TableRow pad darkBorder style={{ justifyContent: 'center', width: '100%' }} grow={1}>
                    <Text size='s' medium center>{mapNames(k).toUpperCase()}</Text>
                  </TableRow>
                  <TableRow noBorder pad grow={0} style={{ justifyContent: 'center', width: '100%' }}>
                    <Text overrides={textCellOverrides()} size='s' medium>{getTypeUnitLabel(k)}</Text>
                    {selectedRound > 1 &&
                      <TranslatedText overrides={textCellOverrides()} size='s' medium value='general.change' default='Change' />}
                  </TableRow>
                </TableCellOthers>
              ))}
            </TableRow>
            {activeBusinessData.teams.map((team, i) => (
              <TableRow key={i} grow={1} style={{ backgroundColor: currentTeam === team.team ? '#ffebd9' : '#fff' }}>
                <TableCellLeft>
                  <Text size='s'>{team.name}</Text>
                </TableCellLeft>
                {Object.keys(team.values).filter((k, i, arr) => {
                  if (!marketShareActive && arr.length > 4) {
                    return k !== 'marketShare'
                  } else if (marketShareActive && arr.length > 4) {
                    if (activeBusiness === 'CREDIT_CARDS' && arr.length > 4) {
                      return k !== 'customers'
                    } else {
                      return k !== 'balances'
                    }
                  }
                  return true
                }).map(k => (
                  <TableCellOthers key={k}>
                    <Text size='s' overrides={textCellOverrides()}>{getValue(k, team.values[k])}</Text>
                    {selectedRound > 1 && team.lastValues &&
                      <Text size='s' overrides={textCellOverrides({ colour: getChangeColor(k, team.values[k], team.lastValues[k]) })}>{displayChange(getChange(k, team.values[k], team.lastValues[k]))}</Text>}
                  </TableCellOthers>
                ))}
              </TableRow>
            ))}
            <TableRow style={{ backgroundColor: theme.colours.grey }} grow={1}>
              <TableCellLeft>
                <Text size='s' medium>Total Market</Text>
              </TableCellLeft>
              {Object.keys(activeBusinessData.teams[0].values).filter((k, i, arr) => {
                if (!marketShareActive && arr.length > 4) {
                  return k !== 'marketShare'
                } else if (marketShareActive && arr.length > 4) {
                  if (activeBusiness === 'CREDIT_CARDS' && arr.length > 4) {
                    return k !== 'customers'
                  } else {
                    return k !== 'balances'
                  }
                }
                return true
              }).map(k => (
                <TableCellOthers key={k}>
                  <Text size='s' overrides={textCellOverrides()} medium>{getTotals(k, activeBusinessData.teams, activeBusiness).value}</Text>
                  {selectedRound > 1 && activeBusinessData.teams[0].lastValues &&
                    <Text size='s' overrides={textCellOverrides()} medium>{getTotals(k, activeBusinessData.teams, activeBusiness).change}</Text>}
                </TableCellOthers>
              ))}
            </TableRow>
          </Table>}
      </Container>
    )
  }
}
